const { getAxiosInstance } = require('../connection');

function generateParticipantFiltersURL(eventId) {
    return `/events/${eventId}/participants/filters`;
}

module.exports = {
    fetch: (eventId) =>
        getAxiosInstance({
            url: generateParticipantFiltersURL(eventId),
            method: 'get',
            json: true,
        }).then((r) => r.data),
    create: (eventId, data) =>
        getAxiosInstance({
            url: generateParticipantFiltersURL(eventId),
            method: 'post',
            json: true,
            data: data,
        }).then((r) => r.data),
    update: (eventId, filterId, data) =>
        getAxiosInstance({
            url: `${generateParticipantFiltersURL(eventId)}/${filterId}`,
            method: 'put',
            json: true,
            data: data,
        }).then((r) => r.data),
    delete: (eventId, filterId) =>
        getAxiosInstance({
            url: `${generateParticipantFiltersURL(eventId)}/${filterId}`,
            method: 'delete',
            json: true,
        }).then((r) => r.data),
};
